export const customSegmentRef = 'customsegment-ref';
